document.addEventListener('DOMContentLoaded', function () {
  const testimonialSections = document.querySelectorAll('.shopify-section--testimonials');
  testimonialSections.forEach(testimonialSection => {
    const testimonialCarousel = testimonialSection.querySelector('.swiper');
    const pagination = testimonialSection.querySelector('.swiper-pagination');

    // Set up default swiper options
    const swiperOptions = {
      slidesPerView: 1,
      spaceBetween: 20,
      pagination: {
        el: pagination,
        clickable: true,
      },
      breakpoints: {
        700: {
          slidesPerView: 1.5,
        },
        1000: {
          slidesPerView: 2.5,
          spaceBetween: 30,
        },
        1300: {
          slidesPerView: 3.5,
          spaceBetween: 40,
        },
      },
    };

    // Check if the element has a data-autoplay attribute
    if (testimonialCarousel.hasAttribute('autoplay')) {
      // Get the delay value from the attribute or fallback to a default (e.g., 3000ms)
      const delay = testimonialCarousel.getAttribute('autoplay') || 3;
      if (delay) {
        swiperOptions.autoplay = {
          delay: parseInt(delay) * 1000,
        };
      }
    }

    // Initialize Swiper with the configured options
    new Swiper(testimonialCarousel, swiperOptions);
  });


  const cardTestimonialSections = document.querySelectorAll('.shopify-section--card-testimonials');
  cardTestimonialSections.forEach(cardTestimonialSection => {
    const cardTestimonialCarousel = cardTestimonialSection.querySelector('.swiper');
    const cardTestimonialPagination = cardTestimonialSection.querySelector('.swiper-pagination');

    // Set up default swiper options
    const swiperOptions = {
      slidesPerView: 1.3,
      spaceBetween: 20,
      centeredSlides: true,
      pagination: {
        el: cardTestimonialPagination,
        clickable: true,
      },
      breakpoints: {
        700: {
          slidesPerView: 1.5,
          centeredSlides: false,
        },
        1000: {
          slidesPerView: 3,
          spaceBetween: 20,
          centeredSlides: false,
        },
        1300: {
          slidesPerView: 3,
          spaceBetween: 40,
          centeredSlides: false,
        },
        1600: {
          slidesPerView: 4,
          spaceBetween: 40,
          centeredSlides: false,
        },
      },
    };

    // Check if the element has a data-autoplay attribute
    if (cardTestimonialCarousel.hasAttribute('autoplay')) {
      // Get the delay value from the attribute or fallback to a default (e.g., 3000ms)
      const delay = cardTestimonialCarousel.getAttribute('autoplay') || 3;
      if (delay) {
        swiperOptions.autoplay = {
          delay: parseInt(delay) * 1000,
        };
      }
    }

    // Initialize Swiper with the configured options
    new Swiper(cardTestimonialCarousel, swiperOptions);
  });

  // Initialize Benefits Slider
  const benefitsSections = document.querySelectorAll('.shopify-section--benefits-slider');
  benefitsSections.forEach(benefitsSection => {
    const benefitsSlider = benefitsSection.querySelector('.swiper');
    if (!benefitsSlider) return;

    new Swiper(benefitsSlider, {
      slidesPerView: 1,
      spaceBetween: 0,
      loop: true,
      // autoplay: {
      //   delay: 5000,
      //   disableOnInteraction: false,
      // },
      pagination: {
        el: benefitsSlider.querySelector('.swiper-pagination'),
        clickable: true,
      },
      navigation: {
        nextEl: benefitsSlider.querySelector('.swiper-button-next'),
        prevEl: benefitsSlider.querySelector('.swiper-button-prev'),
      },
    });
  });

});


(function() {
  // Handle clicks anywhere in the document
  document.addEventListener('click', function(event) {
    // Check if the clicked element or any of its parents match the selector
    const variantPicker = event.target.closest('variant-picker');
    const popover = event.target.closest('.popover');
    if (!variantPicker && !popover) return;  // If not within a variant-picker, exit

    const option = event.target.closest('.popover__value-option');
    if (!option) return;

    if(popover) {
      const popoverId = popover.id;

      const button = document.querySelector(`[aria-controls="${popoverId}"] span`);
      if (button) {
        const text = option.textContent.trim();
        button.textContent = text;
      }
    }
  });
})();
